module.exports = __webpack_public_path__ + "img/normal.22ff3018.svg";